import { Content } from 'src/contexts/ContentContext';
import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { Stack } from 'src/core/ui';
import { BoostSolidIconBrand } from 'src/svgs/BoostSolidIconBrand';
import { BoostSolidIconWhite } from 'src/svgs/BoostSolidIconWhite';
import { ContentId } from 'src/utils/constants/contentId';

import * as styles from './CampaignModal.css';

export const CampaignModalIntroHeader = () => {
  const { isDarkMode } = useSiteTheme();

  const BoostIcon = isDarkMode ? BoostSolidIconWhite : BoostSolidIconBrand;
  return (
    <Stack
      direction="column"
      alignItems="center"
      gap="l"
      width="full"
      className={styles.boostHeaderContainer}
    >
      <BoostIcon size="56px" />
      <span className={styles.boostHeaderText}>
        <Content id={ContentId.IntroducingBoost} />
      </span>
      <span className={styles.boostSubHeaderTextSmall}>
        <Content id={ContentId.BoostIntroMessage} />
      </span>
    </Stack>
  );
};
